import styled from 'styled-components';
import { Box, Card } from '@mui/material';
import { styled as muiStyled } from '@mui/material/styles';
interface IContainer {
  isDark: Boolean;
}
const Container = styled.div`
  padding: 20px;

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${(props: IContainer) => (props.isDark ? '#121212' : '#fff')} inset !important;
    box-shadow: 0 0 0px 1000px ${(props: IContainer) => (props.isDark ? '#121212' : '#fff')} inset !important;
  }
`;

const LatenessContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 0px 10px 0px;
  flex-wrap: wrap;
`;

const Form = styled.form`
  display: flex;
  width: 100%;
  margin-top: 20px;
`;

const OptionCard = muiStyled(Card, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected: boolean }>(({ theme, selected }) => ({
  cursor: 'pointer',
  padding: theme.spacing(1.875),
  borderRadius: 12,
  boxShadow: 'none',
  transition: theme.transitions.create(['border-color', 'background-color'], {
    duration: theme.transitions.duration.shortest,
  }),
  border: selected
    ? `2px solid ${theme.palette.primary.main}`
    : `1px solid ${theme.palette.divider}`,
  backgroundColor: selected
    ? theme.palette.action.selected
    : theme.palette.background.paper,
  '&:hover': {
    borderColor: selected ? theme.palette.primary.main : theme.palette.text.secondary,
  },
}));

const OptionsGrid = muiStyled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(230px, 1fr))',
  gap: theme.spacing(1.5),
  width: '100%',
}));


export { Container, Form, LatenessContainer, OptionsGrid, OptionCard };
